export default __webpack_public_path__ + "static/media/7.59f021bf.jpg";